import styled from "styled-components";

const VoterSectionText = styled.div`
  color: rgba(0, 0, 0, 0.9);
  max-width: 480px;
`;

const MutedNote = styled.div`
  margin-top: 10px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
`;

const ContactEmail = styled.span`
  color: rgba(0, 0, 0, 0.75);
`;

const SmallGap = styled.div`
  margin-top: 12px;
`;

const NoMatch = () => (
  <VoterSectionText>
    No voter record found linked to your contact info.
    <MutedNote>
      To connect your account to your voter registration, your Verified Voice
      contact info needs to match {"what's"} on your Florida voter record.
      Contact us at <ContactEmail>info@verifiedvoice.org</ContactEmail> to get
      set up.
      <SmallGap />
      We can look up what contact info is on your voter record, add it to your
      Verified Voice account, or guide you on updating your voter registration.
    </MutedNote>
  </VoterSectionText>
);

export default NoMatch;
